/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { getUrlParams } from './getUrlParams.js';

export function anchorLinks() {
  var formPreference = getUrlParams()["form"];
  if (formPreference === 'artist-network') {
    setTimeout(function () {
      locoScroll.scrollTo(document.querySelector('#artist-network'));
    }, 1500);
  }

  $('.artistAnchor').on('click tap', function(e) {
    e.preventDefault();
    locoScroll.scrollTo(document.querySelector('#artist-network'));
  });
}
